import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ChatRoomListItem from "../components/ChatRoomListItem"
import LoadingCard from '../components/LoadingCard';

import { 
  updateChatRoomRead, 
  getMoreChatRoomUsers
} from "../actions/chat"

import { getUserData } from "../actions/user";

function Chat(props) {
  const { user, journal, history, getUserData: getUserDataAction, updateChatRoomRead: updateChatRoomReadAction, getMoreChatRoomUsers: getMoreChatRoomUsersAction } = props
  const [currentUsername, setCurrentUsername] = useState(null)
  const [nextToken, setNextToken] = useState(null)

  useEffect(() => {
    setCurrentUsername(user.accountData.idToken.payload["cognito:username"])
    user.userData && setNextToken(user.userData.chatRoomUser.nextToken)
  }, [user.accountData, user.userData])

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (user.isAuthenticated)
          await getUserDataAction(user.accountData.idToken.payload["cognito:username"], journal.myJournalLimit);
      } catch (err) {
        console.log(err);
      }
    }
    fetchUserData()
  // Run once on mount — user data is already kept up to date by subscriptions
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (user.userData === null) {
    return (
      <div className="chat Container">
        <div className="Container--side-padding header">
          <h1>Chat</h1>
        </div>  
        <LoadingCard />
      </div>
    )
  }
  
  const userHasSeenTheLastMessage = async (callback) => {
    await updateChatRoomReadAction(callback, true)
  }

  const loadMoreChatRooms = async () => {
    if(nextToken){
      await getMoreChatRoomUsersAction(currentUsername, nextToken)
    }
  }

  const renderChatList = user.userData.chatRoomUser.items.map( chat => {
    return <ChatRoomListItem key={chat.id} {...chat} currentUser={currentUsername} history={history} userHasSeenTheLastMessage={userHasSeenTheLastMessage} />
  })

  return (
    <div className="chat Container">
      <div className="Container--side-padding header">
        <h1>Chat</h1>
      </div>

        <div className="Container">
          {renderChatList.length > 0 ? 
            renderChatList
          : 
          <div className="chat Container">
            <div className="Container Container--sm sm-form no-chat-found">
            <h1><span role="img" aria-label="Sweat">😅</span><br />No chats yet</h1>
            <p><button className="btn-secondary" onClick={() => history.push("/following/" + currentUsername)}>Find someone to talk to </button></p>
            </div>
          </div>
          }
          {nextToken && <div className="load-more"><button className="btn-secondary" onClick={loadMoreChatRooms} id="chat_load_more_chat_rooms">Load more</button></div>}
        </div>

    </div>
  );
}

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateChatRoomRead,
      getMoreChatRoomUsers,
      getUserData
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat)
